<template>
  <a :class="$style.link"
     :disabled="disabled"
     :href="href"
     :ref="ref"
     :style="style"
     :target="target">
    <slot />
  </a>
</template>

<script>
  import { DefaultPseudoClassAttributeNames,
           DefaultPseudoClassVariableNames,
           getPseudoClassesObject,
           filterObjectByArray} from '@js/vue-style-utils'

  export default {
    name: 'BaseLink',
    inheritAttrs: false,
    props: {
      href: { type: String, required: false, default: '#' },
      disabled: { type: Boolean, required: false, default: false },
      openInCurrentTab: { type: Boolean, required: false, default: false },
    },
    data: function () {
      return {
        postfixes: ['', 'hover', 'active', 'disabled'],
        ref: 'noopener noreferrer',
        style: {
          boxSizing: 'border-box',
          display: 'inline-box',
        },
        target: '_blank',
      };
    },
    created: function () {
      this.ref = this.openInCurrentTab ? null : this.ref;
      this.target = this.openInCurrentTab ? '_self' : this.target;

      const classObject = getPseudoClassesObject(
        this.$attrs, DefaultPseudoClassAttributeNames,
        '--base-link-', DefaultPseudoClassVariableNames, this.postfixes);
      const attrs = filterObjectByArray(
        this.$attrs, DefaultPseudoClassAttributeNames);

      this.style = {
        ...this.style,
        ...attrs,
        ...classObject,
      };
    },
  };
</script>

<style lang="stylus" module>
  .link
    background-color var(--base-link-background-color)
    border var(--base-link-border)
    border-radius var(--base-link-border-radius)
    border-width var(--base-link-border-width)
    box-shadow var(--base-link-box-shadow)
    color var(--base-link-color)
    cursor var(--base-link-cursor)
    font-family var(--base-link-font-family)
    font-size var(--base-link-font-size)
    font-weight var(--base-link-font-weight)
    line-height var(--base-link-line-height)
    text-decoration var(--base-link-text-decoration)
    &:hover
      background-color var(--base-link-background-color-hover)
      border var(--base-link-border-hover)
      border-radius var(--base-link-border-radius-hover)
      border-width var(--base-link-border-width-hover)
      box-shadow var(--base-link-box-shadow-hover)
      color var(--base-link-color-hover)
      cursor var(--base-link-cursor-hover)
      font-family var(--base-link-font-family-hover)
      font-size var(--base-link-font-size-hover)
      font-weight var(--base-link-font-weight-hover)
      line-height var(--base-link-line-height-hover)
      text-decoration var(--base-link-text-decoration-hover)
    &:active
      background-color var(--base-link-background-color-active)
      border var(--base-link-border-active)
      border-radius var(--base-link-border-radius-active)
      border-width var(--base-link-border-width-active)
      box-shadow var(--base-link-box-shadow-active)
      color var(--base-link-color-active)
      cursor var(--base-link-cursor-active)
      font-family var(--base-link-font-family-active)
      font-size var(--base-link-font-size-active)
      font-weight var(--base-link-font-weight-active)
      line-height var(--base-link-line-height-active)
      text-decoration var(--base-link-text-decoration-active)
    &[disabled]
      background-color var(--base-link-background-color-disabled)
      border var(--base-link-border-disabled)
      border-radius var(--base-link-border-radius-disabled)
      border-width var(--base-link-border-width-disabled)
      box-shadow var(--base-link-box-shadow-disabled)
      color var(--base-link-color-disabled)
      cursor var(--base-link-cursor-disabled)
      font-family var(--base-link-font-family-disabled)
      font-size var(--base-link-font-size-disabled)
      font-weight var(--base-link-font-weight-disabled)
      line-height var(--base-link-line-height-disabled)
      text-decoration var(--base-link-text-decoration-disabled)
</style>
